import { Typography } from "antd";
import { observer } from "mobx-react";

const ReportDetailsComponent = observer(() => {
	return (
		<div>
			<Typography.Title>Report Details Page</Typography.Title>
		</div>
	);
});

export default ReportDetailsComponent;
